import axios from 'axios';

const VIA_CEP_URL = 'https://viacep.com.br/ws';

export const getCepFromViaCepApi = (cep: string) => {
  return axios.get(`${VIA_CEP_URL}/${cep}/json`);
};
